import { AfterViewInit, Directive, inject } from '@angular/core';
import { DatePicker } from '@openng/optimus-ui/datepicker';

/**
 * Workaround pro PrimeNG 20.x: ikona vymazani (`showClear`) se v `p-datepicker` vykresluje podle
 * `inputfieldViewChild.nativeElement.value`, ale pri hodnote nastavene pred inicializaci view
 * (writeValue z formulare pred ngAfterViewInit) uz DatePicker (OnPush) nikdo neoznaci ke kontrole,
 * takze ikona chybi, dokud uzivatel hodnotu nezmeni. Po inicializaci view proto jednou naplanujeme
 * markForCheck v mikrotasku (zone pak spusti change detection).
 *
 * PrimeNG 19 pouzivalo podminku `value != null` (model), kde problem nebyl. Po prechodu na
 * Optimus UI overit, zda je workaround stale potreba.
 */
@Directive({
  // selektor musi cilit na element PrimeNG, ne na nas prefix
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'p-datepicker[showClear]',
})
export class DatepickerClearIconFixDirective implements AfterViewInit {
  private readonly datePicker = inject(DatePicker, { host: true });

  ngAfterViewInit(): void {
    queueMicrotask(() => this.datePicker.cd.markForCheck());
  }
}
